<div class="apj-div">
  <h2>APAC Gene.AI Community App</h2>
  <h6>"Below is a fantastic example of community contribution and the great work being done to create solutions on the Gene.AI platform." - The GenAI CoE</h6>
  <iframe class="subform" id="nobackground" name="nobackground" [src]="url" width="100%" height="100%" frameborder="0" scrolling="no" allowtransparency="true" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>
